import type { OrganizationsListProviderProps } from "./organizations-list-provider.type";

import { ListProvider } from "@/modules/list";

export const OrganizationsListProvider = ({
  children,
  ...props
}: OrganizationsListProviderProps) => {
  return (
    <ListProvider endpoint="organizations" {...props}>
      {children}
    </ListProvider>
  );
};
